import { render } from "./DetailMovementTable.vue?vue&type=template&id=1967a3fe&scoped=true"
import script from "./DetailMovementTable.vue?vue&type=script&lang=js"
export * from "./DetailMovementTable.vue?vue&type=script&lang=js"

import "./DetailMovementTable.vue?vue&type=style&index=0&id=1967a3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1967a3fe"]])

export default __exports__